import { Agent, AgentKeys } from '@ag-common-lib/public-api';
import { from, map } from 'rxjs';
import { Injectable } from '@angular/core';
import { AgentSearchService, DynamicListsGroupService } from 'ag-common-svc/public-api';

@Injectable()
export class NotificationAddListsModalService {
  agents$ = from(
    this.agentSearchService.search({ sort: [{ selector: AgentKeys.p_agent_first_name, desc: false }] }),
  ).pipe(map(response => (response?.data ?? []) as Agent[]));
  lists$ = this.dynamicListsGroupService.lists$;

  constructor(
    private agentSearchService: AgentSearchService,
    private dynamicListsGroupService: DynamicListsGroupService,
  ) {}
}
